import { useEffect, RefObject } from 'react';

interface ObserverOptions {
  threshold?: number | number[];
}

const useIntersectionObserver = (
  callback: IntersectionObserverCallback,
  targetRef: RefObject<Element>,
  options?: ObserverOptions,
): void => {
  useEffect(() => {
    const observer = new IntersectionObserver(callback, options);

    const currentElement = targetRef?.current;
    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, [callback, options, targetRef]);
};

export default useIntersectionObserver;
